import { z } from 'zod'

// GET /domain: the account's own domains, read from the database alone.
export const DomainSummary = z.object({
  id: z.number(),
  name: z.string(),
  name_ace: z.string().optional(),
  registration_status: z.string(),
  registered: z.number(),
  // Absent for a domain registered elsewhere and carried here for mail.
  registration: z
    .object({
      subscription_id: z.number(),
      status: z.string(),
      active_until: z.number(),
      canceled: z.number().optional()
    })
    .optional()
})
export type DomainSummary = z.infer<typeof DomainSummary>

export const DomainListResponse = z.object({
  domains: z.array(DomainSummary),
  total_count: z.number(),
  limit: z.number(),
  offset: z.number()
})
export type DomainListResponse = z.infer<typeof DomainListResponse>
